import { DEFAULT_CURRENCY } from 'src/app/config/app.config';
import { PAYMENT_METHOD } from 'src/app/shared/enums/payment-method.enum';
import { PAYMENT_TYPE } from 'src/app/shared/enums/payment-type.enum';
import { COLORS } from '../../shared/utils/colors.constant';
import { IAccount } from '../entities/account/infrastructure/interfaces/account-storage.interface';
import { ENTRY_TYPE } from '../entities/entry/domain/enum/entry-type.enum';
import { IEntry } from '../entities/entry/infrastructure/interface/entry-storage.interface';
import { IPayment } from '../entities/payment/domain/interfaces/payment-storage.interface';
import { PAYMENT_STATUS } from '../enums/payment-status.enum';

/**
 * Mock entry for basic consumption item
 */
export const entryMock1: IEntry = {
  _id: '57579742-77e8-4b4e-a255-18e0f009b547',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  product_name: 'Copa Cardhu',
  product_id: '64998ad9bd96e7084639eeef',
  associated_id: '64998ad9bd96e7084639eeef',
  associated_name: 'Copa Cardhu',
  quantity: 1,
  quantity_to_display: 1,
  color: COLORS.blue,
  currency: DEFAULT_CURRENCY,
  activated: true,
  unit_price: 25,
  unit_price_modified: 25,
  initial_unit_price: 25,
  total: 25,
  created_at: Date.now(),
  closed_at: 0,
  initial_total: 25,
  refund_id: undefined,
  account_id: 'd5fd2177-0071-4846-a00a-027825fe70a2',
  sale_format_id: undefined,
  sale_format_name: undefined,
  vat: 0,
  taxes_ids: [],
  isSelected: false,
  discount: undefined,
  consumption: undefined,
  isDecreaseDisabled: false,
  selected_addons: [],
  addons_total: 0,
  addons_quantity: 0,
  max_addons: 0,
  product_format_id: undefined,
  type: ENTRY_TYPE.product,
  limit: undefined,
};

/**
 * Mock entry for premium product
 */
export const entryMock2: IEntry = {
  _id: '57579742-77e8-4b4e-a255-18e0f009b548',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  product_name: 'Botella Champagne Dom Pérignon',
  product_id: '64998ad9bd96e7084639eeef',
  associated_id: '64998ad9bd96e7084639eeef',
  associated_name: 'Botella Champagne Dom Pérignon',
  quantity: 1,
  quantity_to_display: 1,
  color: COLORS.yellow,
  currency: DEFAULT_CURRENCY,
  activated: true,
  unit_price: 350,
  unit_price_modified: 350,
  initial_unit_price: 350,
  total: 350,
  created_at: Date.now(),
  closed_at: 0,
  initial_total: 350,
  refund_id: undefined,
  account_id: 'd5fd2177-0071-4846-a00a-027825fe70a2',
  sale_format_id: undefined,
  sale_format_name: undefined,
  vat: 0,
  taxes_ids: [],
  isSelected: false,
  discount: undefined,
  consumption: undefined,
  isDecreaseDisabled: false,
  selected_addons: [],
  addons_total: 0,
  addons_quantity: 0,
  max_addons: 0,
  product_format_id: undefined,
  type: ENTRY_TYPE.product,
  limit: undefined,
};

/**
 * Mock entry for multiple quantity item
 */
export const entryMock3: IEntry = {
  _id: '57579742-77e8-4b4e-a255-18e0f009b549',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  product_name: 'Cerveza Estrella Galicia',
  product_id: '64998ad9bd96e7084639eeef',
  associated_id: '64998ad9bd96e7084639eeef',
  associated_name: 'Cerveza Estrella Galicia',
  quantity: 4,
  quantity_to_display: 4,
  color: COLORS.amber,
  currency: DEFAULT_CURRENCY,
  activated: true,
  unit_price: 5,
  unit_price_modified: 5,
  initial_unit_price: 5,
  total: 20,
  created_at: Date.now(),
  closed_at: 0,
  initial_total: 20,
  refund_id: undefined,
  account_id: 'd5fd2177-0071-4846-a00a-027825fe70a2',
  sale_format_id: undefined,
  sale_format_name: undefined,
  vat: 0,
  taxes_ids: [],
  isSelected: false,
  discount: undefined,
  consumption: undefined,
  isDecreaseDisabled: false,
  selected_addons: [],
  addons_total: 0,
  addons_quantity: 0,
  max_addons: 0,
  product_format_id: undefined,
  type: ENTRY_TYPE.product,
  limit: undefined,
};

/**
 * Mock entry for booking related entry
 */
export const entryMockBooking: IEntry = {
  _id: '57579742-77e8-4b4e-a255-18e0f009b550',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  product_name: 'Mesa VIP - Reserva',
  product_id: undefined,
  associated_id: 'booking-001',
  associated_name: 'Mesa VIP - Reserva',
  quantity: 1,
  quantity_to_display: 1,
  color: COLORS.purple,
  currency: DEFAULT_CURRENCY,
  activated: true,
  unit_price: 100,
  unit_price_modified: 100,
  initial_unit_price: 100,
  total: 100,
  created_at: Date.now(),
  closed_at: 0,
  initial_total: 100,
  refund_id: undefined,
  account_id: 'd5fd2177-0071-4846-a00a-027825fe70a2',
  sale_format_id: undefined,
  sale_format_name: undefined,
  vat: 0,
  taxes_ids: [],
  isSelected: false,
  discount: undefined,
  consumption: undefined,
  isDecreaseDisabled: false,
  selected_addons: [],
  addons_total: 0,
  addons_quantity: 0,
  max_addons: 0,
  product_format_id: undefined,
  type: ENTRY_TYPE.booking,
  limit: undefined,
};

/**
 * Mock payment - Cash payment
 */
export const paymentMockCash: IPayment = {
  _id: '776dbb76-2e3c-4ab1-b33c-927a70395a36',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  amount: 50,
  renderedEntries: [],
  entries: [],
  operation: {
    amount: 50,
    change: 5,
    operation_id: '1234',
    payment_method: PAYMENT_METHOD.cash,
    payment_type: PAYMENT_TYPE.full,
  },
  paymentResume: {
    changeDelivered: 5,
    totalAmount: 50,
    totalDelivered: 55,
    paymentMethod: PAYMENT_METHOD.cash,
    paymentType: PAYMENT_TYPE.full,
  },
  isProductPayment: false,
  cash_drawer_count_id: 'ym4thyiet0bdh28ms3p6t0alhMcmwjz4',
  cash_drawer_id: 'Plxn6hqkb000e51o90wz49o6kMyxOLSP',
  payment_method: PAYMENT_METHOD.cash,
  payment_type: PAYMENT_TYPE.full,
  divisa: DEFAULT_CURRENCY,
  resource_type: 'drinks',
  status: PAYMENT_STATUS.completed,
  provider: 'internal',
  additional_data: undefined,
  transaction_history: undefined,
  closed_at: undefined,
  ticket: undefined,
  serie: 'FSA01-000002538',
  created_by: 'Glxn68lj2000951o9agr69twdzAHaK5D',
  created_at: Date.now(),
  updated_by: undefined,
  updated_at: 0,
  removed_at: 0,
  removed_by: undefined,
  paid_at: Date.now(),
};

/**
 * Mock payment - Card payment
 */
export const paymentMockCard: IPayment = {
  _id: '776dbb76-2e3c-4ab1-b33c-927a70395a37',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  amount: 125,
  renderedEntries: [],
  entries: [],
  operation: {
    amount: 125,
    change: 0,
    operation_id: '1235',
    payment_method: PAYMENT_METHOD.card,
    payment_type: PAYMENT_TYPE.full,
  },
  paymentResume: {
    changeDelivered: 0,
    totalAmount: 125,
    totalDelivered: 125,
    paymentMethod: PAYMENT_METHOD.card,
    paymentType: PAYMENT_TYPE.full,
  },
  isProductPayment: false,
  cash_drawer_count_id: 'ym4thyiet0bdh28ms3p6t0alhMcmwjz4',
  cash_drawer_id: 'Plxn6hqkb000e51o90wz49o6kMyxOLSP',
  payment_method: PAYMENT_METHOD.card,
  payment_type: PAYMENT_TYPE.full,
  divisa: DEFAULT_CURRENCY,
  resource_type: 'drinks',
  status: PAYMENT_STATUS.completed,
  provider: 'adyen',
  additional_data: undefined,
  transaction_history: undefined,
  closed_at: undefined,
  ticket: undefined,
  serie: 'FSA01-000002539',
  created_by: 'Glxn68lj2000951o9agr69twdzAHaK5D',
  created_at: Date.now(),
  updated_by: undefined,
  updated_at: 0,
  removed_at: 0,
  removed_by: undefined,
  paid_at: Date.now(),
};

/**
 * Mock payment - Partial payment
 */
export const paymentMockPartial: IPayment = {
  _id: '776dbb76-2e3c-4ab1-b33c-927a70395a38',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  amount: 75,
  renderedEntries: [],
  entries: [],
  operation: {
    amount: 75,
    change: 0,
    operation_id: '1236',
    payment_method: PAYMENT_METHOD.cash,
    payment_type: PAYMENT_TYPE.byAmount,
  },
  paymentResume: {
    changeDelivered: 0,
    totalAmount: 75,
    totalDelivered: 75,
    paymentMethod: PAYMENT_METHOD.cash,
    paymentType: PAYMENT_TYPE.byAmount,
  },
  isProductPayment: false,
  cash_drawer_count_id: 'ym4thyiet0bdh28ms3p6t0alhMcmwjz4',
  cash_drawer_id: 'Plxn6hqkb000e51o90wz49o6kMyxOLSP',
  payment_method: PAYMENT_METHOD.cash,
  payment_type: PAYMENT_TYPE.byAmount,
  divisa: DEFAULT_CURRENCY,
  resource_type: 'drinks',
  status: PAYMENT_STATUS.completed,
  provider: 'internal',
  additional_data: undefined,
  transaction_history: undefined,
  closed_at: undefined,
  ticket: undefined,
  serie: 'FSA01-000002540',
  created_by: 'Glxn68lj2000951o9agr69twdzAHaK5D',
  created_at: Date.now(),
  updated_by: undefined,
  updated_at: 0,
  removed_at: 0,
  removed_by: undefined,
  paid_at: Date.now(),
};

/**
 * Mock for an empty account - Just created, no entries or payments
 * Total: 0€
 * Paid: 0€
 * Remaining: 0€
 * Status: Open
 */
export const accountMockEmpty: IAccount = {
  _id: 'acc-001',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-001',
  device_id: 'device-001',
  cash_drawer_id: 'drawer-001',
  products_quantity: 0,
  total: 0,
  service_id: 'service-001',
  location_id: 'location-001',
  entries: [],
  trackId: 'track-001',
  payments_ids: [],
  refund_ids: [],
  totalAmount: 0,
  zona_id: 'zone-001',
  created_at: Date.now() - 2 * 60 * 60 * 1000,
  created_by: 'user-001',
  updated_at: Date.now() - 2 * 60 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Mesa recién abierta',
  name: 'Mesa 1',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [],
  totalPaid: 0,
  totalRemaining: 0,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.blue,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for an account with single entry - Basic consumption
 * Total: 25€ (1 Copa Cardhu)
 * Paid: 0€
 * Remaining: 25€
 * Status: Open
 */
export const accountMockSingleEntry: IAccount = {
  _id: 'acc-002',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-002',
  device_id: 'device-002',
  cash_drawer_id: 'drawer-002',
  products_quantity: 1,
  total: 25,
  service_id: 'service-002',
  location_id: 'location-002',
  entries: [entryMock1],
  trackId: 'track-002',
  payments_ids: [],
  refund_ids: [],
  totalAmount: 25,
  zona_id: 'zone-002',
  created_at: Date.now() - 1 * 60 * 60 * 1000,
  created_by: 'user-002',
  updated_at: Date.now() - 30 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Cliente consumiendo tranquilamente',
  name: 'Mesa 2',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [],
  totalPaid: 0,
  totalRemaining: 25,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.green,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for an account with multiple entries - Mixed consumption
 * Total: 395€ (1 Copa Cardhu + 1 Botella Champagne + 4 Cervezas)
 * Paid: 0€
 * Remaining: 395€
 * Status: Open
 */
export const accountMockMultipleEntries: IAccount = {
  _id: 'acc-003',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-003',
  device_id: 'device-003',
  cash_drawer_id: 'drawer-003',
  products_quantity: 6,
  total: 395,
  service_id: 'service-003',
  location_id: 'location-003',
  entries: [entryMock1, entryMock2, entryMock3],
  trackId: 'track-003',
  payments_ids: [],
  refund_ids: [],
  totalAmount: 395,
  zona_id: 'zone-003',
  created_at: Date.now() - 3 * 60 * 60 * 1000,
  created_by: 'user-003',
  updated_at: Date.now() - 15 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Mesa VIP con consumo alto',
  name: 'Mesa VIP 3',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [],
  totalPaid: 0,
  totalRemaining: 395,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.purple,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for an account with partial payment - Partially paid
 * Total: 25€ (1 Copa Cardhu)
 * Paid: 50€ (Cash payment with change)
 * Remaining: 0€ (Overpaid)
 * Status: Open
 */
export const accountMockPartiallyPaid: IAccount = {
  _id: 'acc-004',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-004',
  device_id: 'device-004',
  cash_drawer_id: 'drawer-004',
  products_quantity: 1,
  total: 25,
  service_id: 'service-004',
  location_id: 'location-004',
  entries: [entryMock1],
  trackId: 'track-004',
  payments_ids: [paymentMockCash._id],
  refund_ids: [],
  totalAmount: 25,
  zona_id: 'zone-004',
  created_at: Date.now() - 2 * 60 * 60 * 1000,
  created_by: 'user-004',
  updated_at: Date.now() - 5 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Cliente pagó con cambio',
  name: 'Mesa 4',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [paymentMockCash],
  totalPaid: 50,
  totalRemaining: 0,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.orange,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for a closed account - Fully paid and closed
 * Total: 395€ (Mixed consumption)
 * Paid: 200€ (Card payment + Cash payment)
 * Remaining: 0€
 * Status: Closed
 */
export const accountMockClosed: IAccount = {
  _id: 'acc-005',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: true,
  waiter_id: 'waiter-005',
  device_id: 'device-005',
  cash_drawer_id: 'drawer-005',
  products_quantity: 6,
  total: 395,
  service_id: 'service-005',
  location_id: 'location-005',
  entries: [entryMock1, entryMock2, entryMock3],
  trackId: 'track-005',
  payments_ids: [paymentMockCard._id, paymentMockPartial._id],
  refund_ids: [],
  totalAmount: 395,
  zona_id: 'zone-005',
  created_at: Date.now() - 4 * 60 * 60 * 1000,
  created_by: 'user-005',
  updated_at: Date.now() - 10 * 60 * 1000,
  removed_at: 0,
  closed_at: Date.now() - 10 * 60 * 1000,
  note: 'Cuenta cerrada exitosamente',
  name: 'Mesa VIP 5',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: 'FSA01-000002541',
  serie: 'FSA01-000002541',
  ticketNumber: 2541,
  ticketSerie: 'FSA01',
  ticketPrefix: 'FSA',
  payments: [paymentMockCard, paymentMockPartial],
  totalPaid: 200,
  totalRemaining: 0,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.red,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for an account with booking - Booking associated account
 * Total: 125€ (1 Copa Cardhu + 1 Booking entry)
 * Paid: 0€
 * Remaining: 125€
 * Status: Open
 * Booking ID: booking-001
 */
export const accountMockWithBooking: IAccount = {
  _id: 'acc-006',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-006',
  device_id: 'device-006',
  cash_drawer_id: 'drawer-006',
  products_quantity: 2,
  total: 125,
  service_id: 'service-006',
  location_id: 'location-006',
  entries: [entryMock1, entryMockBooking],
  trackId: 'track-006',
  payments_ids: [],
  refund_ids: [],
  totalAmount: 125,
  zona_id: 'zone-006',
  created_at: Date.now() - 1 * 60 * 60 * 1000,
  created_by: 'user-006',
  updated_at: Date.now() - 20 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Mesa con reserva confirmada',
  name: 'Mesa VIP Reserva',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [],
  totalPaid: 0,
  totalRemaining: 125,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.indigo,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: 'booking-001',
};

/**
 * Mock for an account with high consumption - Premium experience
 * Total: 725€ (Premium consumption)
 * Paid: 125€
 * Remaining: 600€
 * Status: Open
 */
export const accountMockHighConsumption: IAccount = {
  _id: 'acc-007',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-007',
  device_id: 'device-007',
  cash_drawer_id: 'drawer-007',
  products_quantity: 3,
  total: 725,
  service_id: 'service-007',
  location_id: 'location-007',
  entries: [entryMock2, entryMock2, entryMock1],
  trackId: 'track-007',
  payments_ids: [paymentMockCard._id],
  refund_ids: [],
  totalAmount: 725,
  zona_id: 'zone-007',
  created_at: Date.now() - 5 * 60 * 60 * 1000,
  created_by: 'user-007',
  updated_at: Date.now() - 1 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Mesa VIP premium con alto consumo',
  name: 'Mesa Platinum',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [paymentMockCard],
  totalPaid: 125,
  totalRemaining: 600,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.yellow,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Mock for an account with only beers - Casual consumption
 * Total: 40€ (8 Cervezas)
 * Paid: 0€
 * Remaining: 40€
 * Status: Open
 */
export const accountMockCasualConsumption: IAccount = {
  _id: 'acc-008',
  negocio_id: 'Mjo4f9o9h01fdjvmmrgn9aoh4s5IBHzX',
  closed: false,
  waiter_id: 'waiter-008',
  device_id: 'device-008',
  cash_drawer_id: 'drawer-008',
  products_quantity: 8,
  total: 40,
  service_id: 'service-008',
  location_id: 'location-008',
  entries: [entryMock3, entryMock3],
  trackId: 'track-008',
  payments_ids: [],
  refund_ids: [],
  totalAmount: 40,
  zona_id: 'zone-008',
  created_at: Date.now() - 2 * 60 * 60 * 1000,
  created_by: 'user-008',
  updated_at: Date.now() - 45 * 60 * 1000,
  removed_at: 0,
  closed_at: 0,
  note: 'Mesa con amigos tomando cervezas',
  name: 'Mesa Terraza 8',
  formatedDate: '',
  formatedHour: '',
  closedFormatedHour: '',
  ticket_id: '',
  serie: '',
  ticketNumber: 0,
  ticketSerie: '',
  ticketPrefix: '',
  payments: [],
  totalPaid: 0,
  totalRemaining: 40,
  priceCurrency: DEFAULT_CURRENCY,
  color: COLORS.amber,
  location: null,
  drawer: null,
  waiter: null,
  serverUpdatedAt: Date.now(),
  actualUpdatedAt: Date.now(),
  booking_id: undefined,
};

/**
 * Collection of all account mocks
 */
export const accountMocks: IAccount[] = [
  accountMockEmpty,
  accountMockSingleEntry,
  accountMockMultipleEntries,
  accountMockPartiallyPaid,
  accountMockClosed,
  accountMockWithBooking,
  accountMockHighConsumption,
  accountMockCasualConsumption,
];

/**
 * Collection of open account mocks (not closed)
 */
export const openAccountMocks: IAccount[] = accountMocks.filter(
  (account) => !account.closed
);

/**
 * Collection of closed account mocks
 */
export const closedAccountMocks: IAccount[] = accountMocks.filter(
  (account) => account.closed
);

/**
 * Collection of account mocks with payments
 */
export const accountMocksWithPayments: IAccount[] = accountMocks.filter(
  (account) => account.payments && account.payments.length > 0
);

/**
 * Collection of account mocks with entries
 */
export const accountMocksWithEntries: IAccount[] = accountMocks.filter(
  (account) => account.entries && account.entries.length > 0
);

/**
 * Collection of account mocks with booking association
 */
export const accountMocksWithBooking: IAccount[] = accountMocks.filter(
  (account) => account.booking_id
);

/**
 * Collection of account mocks for testing different scenarios
 */
export const accountMockScenarios = {
  empty: accountMockEmpty,
  singleEntry: accountMockSingleEntry,
  multipleEntries: accountMockMultipleEntries,
  partiallyPaid: accountMockPartiallyPaid,
  closed: accountMockClosed,
  withBooking: accountMockWithBooking,
  highConsumption: accountMockHighConsumption,
  casualConsumption: accountMockCasualConsumption,
};

/**
 * Legacy mock for backward compatibility
 */
export const accountMock: IAccount = accountMockSingleEntry;

/**
 * Legacy mock with entries for backward compatibility
 */
export const accountMockWithEntries: IAccount = accountMockMultipleEntries;
